<template>
	<div class="skySlogan">
		<div class="info">
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
				<el-form-item label="最终到达网址" prop="finalUrls">
					<el-input v-model="ruleForm.finalUrls" @input="input"></el-input>
				</el-form-item>
			</el-form>
			<div>
				<div class="batch" @click="batchTitle">批量添加标题</div>
				<div class="batch" @click="openTitleDrawer(1)">AI撰写</div>
				<adDelete
					ref="titleForm"
					title="广告标题"
					ispromotion
					:Arr="list.headlines"
					:maxquantity="15"
					:minquantity="2"
					label="标题"
					:maxlength="30"
					@getList="getAdTitle"
					@getValidateTit="getValidateTit"
				></adDelete>
			</div>
			<div>
				<div class="batch" @click="batchExplain">批量添加说明</div>
				<div class="batch" @click="openTitleDrawer(2)">AI撰写</div>
				<adDelete
					ref="adInfoForm"
					title="广告说明"
					ispromotion
					:Arr="list.descriptions"
					:maxquantity="4"
					:minquantity="1"
					label="说明"
					:maxlength="90"
					@getList="getAdInfoTitle"
					@getValidateInfo="getValidateInfo"
				></adDelete>
			</div>
		</div>
		<div class="preview">
			<div>广告效果预览</div>
			<div class="preInfo">
				<div>
					<span>广告· {{ list.finalUrls }}</span>
				</div>
				<div>
					<span v-for="(url, key, id) in list['headlines']" :key="id" class="tit">{{ (id + 1 == (Object.values(list.headlines).length)) ? url : url+' | ' }}</span>
				</div>
				<div>
					<span v-for="(url, key, id) in list['descriptions']" :key="id">{{ url + '。' }}</span>
				</div>
			</div>
		</div>
		<el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="batchDialog">
			<el-input
				:autosize="{ minRows: 8, maxRows: 11 }"
				type="textarea"
				:placeholder="placeholder"
				v-model="textarea"
			>
			</el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="batchDialog = false">取 消</el-button>
				<el-button type="primary" @click="batchSave">确 定</el-button>
			</span>
		</el-dialog>
		<aiDrawer :title="aiTitle" :visible.sync="titleDrawer" :product="selecteditem" :ruleType="ruleType" @done="addData"></aiDrawer>
		<selectProductDetail ref="selectProductDetail" v-model="selectProductList" :domain="domain" :isShowTit="false" :ruleType="ruleType" @openTitleDrawer="openTitleDrawer"></selectProductDetail>
	</div>
</template>
<script>
// import { mapGetters } from 'vuex';
import adDelete from './adDelete.vue';
import aiDrawer from "@/components/adsOnlineAuto/com/aiDrawer.vue";
import selectProductDetail from '@/components/iglobalwin/formComponents/common/selectProduct/selectProductDetail.vue';
import adsNewOnline from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	name: 'skySlogan',
  components: { adDelete, aiDrawer, selectProductDetail },
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					headlines: [],
					descriptions: [],
					finalUrls: ''
				};
			},
			required: true
		},
		domain: {
			// 域名
			type: String,
			default: ''
		},
		productUrl: {
			// 最终网址
			type: [String, Array],
			default: ''
		},
		isValidate: {
			type: Boolean,
		}
	},
	computed: {
		// ...mapGetters(['activeWebsite']),
		domainName() {
			return 'https://' + this.domain;
		},
	},
	watch: {
		value: {
			handler: function(val) {
				if(val.headlines.length < 3) {
          // 标题小于三直接增加3个空的
          let len = val.headlines;
					let arr = [];
          for(let i = 0; i < 3-len.length; i++) {
            arr.push('');
          }
          [...len, ...arr].forEach((item, id) => {
						this.$set(this.list.headlines,'content'+id, item)
          })
					this.handleChange(this.list)
        }else {
					this.list.headlines = this.convert(val.headlines);
				}
				if(val.descriptions.length < 2) {
          // 说明小于2直接增加2个空的
          let len = val.descriptions;
					let arr = [];
          for(let i = 0; i < 2-len.length; i++) {
            arr.push('');
          }
          [...len, ...arr].forEach((item, id) => {
						this.$set(this.list.descriptions,'content'+id, item)
          })
					this.handleChange(this.list)
        }else {
					this.list.descriptions = this.convert(val.descriptions);
				}
				if(val.finalUrls) {
					this.list.finalUrls = val.finalUrls;
					this.ruleForm.finalUrls = val.finalUrls;
				}
			},
			immediate: true,
      deep: true,
		},
		productUrl: {
			handler: function(val) {
				if(val && val.length) {
					this.$set(this.list,'finalUrls',this.domainName + val[0].path);
					this.$set(this.ruleForm,'finalUrls',this.domainName + val[0].path);
					this.selectProductList = val; // 外部产品数据 同步 到 ai撰写 产品数据弹框
					this.handleChange(this.list);
				}
			},
			// immediate: true,
			deep: true,
		},
		isValidate: {
			handler: function(val) {
				if(val) {
					this.info = val;
					this.tit = val;
				}
			},
			immediate: true,
			deep: true,
		},
		selectProductList: {
			handler: function(val) {
				if(val && val.length) {
					this.$set(this.list,'finalUrls',this.domainName + val[0].path);
					this.$set(this.ruleForm,'finalUrls',this.domainName + val[0].path);
					this.handleChange(this.list);
				}
			},
			// immediate: true,
			deep: true,
		}
	},
	mounted() {
		if(!this.value.finalUrls) {
			this.$nextTick(() => {
				// 清除第一次校验
				this.$refs.ruleForm.clearValidate();
			})
		}
	},
	data() {
		var validateUrl = (rule, value, callback) => {
			let domain = this.domainName;
			let reg=/^https:\/\//;
			if(value){
				if (!reg.test(value)||value.search(domain) == -1) {
					callback(new Error('非客户网站'));
				} else {
					callback();
				}
			}else{
				callback(new Error('不能为空'));
			}
		};
		return {
			list: {
        headlines: {},
				descriptions: {},
				finalUrls: ''
      },
			ruleForm: {
				finalUrls: '',
			},
			rules: {
				finalUrls: [
					{ required: true, validator: validateUrl, trigger: 'change' }
				],
			},
			tit: false,
			info: false,
			batchDialog: false,
			textarea: '',
			dialogTitle: '',
			aiTitle: '自动生成广告标题',
			titleDrawer: false, // 标题推荐抽屉
			ruleType: 1,// ai自动生成类型 1、广告标题 2、广告描述 3、广告附加信息
			selecteditem: {
				imgPath: '',
				title:'',
				automationContentId: ''
			},
			placeholder: '',
			selectProductList: [],
		};
	},
	methods: {
		convert(val) {
			let obj = {};
			val.forEach((item, id) => {
				obj['content' + id] = item;
			})
			return obj;
		},
		getValidateTit(val) {
			// 获取标题校验成功还是失败
			this.tit = val;
		},
		getValidateInfo(val) {
			// 获取说明校验成功还是失败
			this.info = val;
		},
		batchTitle() {
			this.batchDialog = true;
			this.dialogTitle = '批量添加标题';
			this.placeholder = '添加标题，每行一条，超出15条的部分将忽略';
		},
		batchExplain() {
			this.batchDialog = true;
			this.dialogTitle = '批量添加说明';
			this.placeholder = '添加标题，每行一条，超出4条的部分将忽略';
		},
		batchSave() {
			let len = 0;
			let titleArr = this.textarea.split('\n').filter(function (s) {
				return s && s.trim();
			});
			if (this.dialogTitle === '批量添加标题') {
				len = this.value.headlines.filter(i => i != '').length || 0;
				titleArr.forEach(v => {
					this.list.headlines['content' + len] = v;
					len += 1;
				});
				this.list.headlines = Object.fromEntries(
					Object.entries(this.list.headlines).filter(([key,val]) => {
							return val != ''
					})
				)
			} else {
				len = this.value.descriptions.filter(i => i != '').length || 0;
				titleArr.forEach(v => {
					this.list.descriptions['content' + len] = v;
					len += 1;
				});
				this.list.descriptions = Object.fromEntries(
					Object.entries(this.list.descriptions).filter(([key,val]) => {
							return val != ''
					})
				)
			}
			this.textarea = '';
			this.batchDialog = false;
			this.handleChange();
		},
    getAdTitle(value) {
			this.list.headlines = value;
			this.handleChange(this.list)
		},
		getAdInfoTitle(value) {
			this.list.descriptions = value;
			this.handleChange(this.list)
		},
		input() {
			this.list.finalUrls = this.ruleForm.finalUrls;
			this.handleChange(this.list)
		},
		handleChange(val) {
			this.$nextTick(() => {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						this.$set(this.list,'finalUrls', this.ruleForm.finalUrls);
						this.$attrs.changeVal(this.tit && this.info); // 判断是否校验成功
					} else {
						this.$attrs.changeVal(false)
					}
				});
				let params = {
					finalUrls: this.list.finalUrls,
					headlines: Object.values(this.list.headlines).slice(0,15),
					descriptions: Object.values(this.list.descriptions).slice(0,4),
				}
				this.$emit('change', params);
				this.$emit('input', params);
			})
		},
		convertDataToObject(data) {
			let len = 0;
			let titleArr = data.filter(function (s) {
				return s.content && s.content.trim();
			});
			if (this.ruleType === 1) {
				// 1、广告标题 2、广告描述
				len = this.value.headlines.filter(i => i != '').length || 0;
				titleArr.forEach(v => {
					this.list.headlines['content' + len] = v.content;
					len += 1;
				});
				this.list.headlines = Object.fromEntries(
					Object.entries(this.list.headlines).filter(([key,val]) => {
							return val != ''
					})
				)
			} else if(this.ruleType === 2) {
				len = this.value.descriptions.filter(i => i != '').length || 0;
				titleArr.forEach(v => {
					this.list.descriptions['content' + len] = v.content;
					len += 1;
				});
				this.list.descriptions = Object.fromEntries(
					Object.entries(this.list.descriptions).filter(([key,val]) => {
							return val != ''
					})
				)
			}
			this.handleChange();
		},
		// 将选中的AI生成结果追加
    addData(val) {
			this.convertDataToObject(val);

    },
		// 打开标题推荐抽屉
    openTitleDrawer(type){
			this.ruleType = type; // 1 标题   2 广告描述
			this.$nextTick(async() => {
				if(this.ruleForm.finalUrls == '') {
					// 最终达到网址为空，则打开产品数据弹框
					this.selectProductList = [];
					this.$refs.selectProductDetail.dialogVisible = true; // 打开产品数据弹框
					return false;
				}
				this.$attrs.aiWrite(this.selectProductList); // 把选中的产品抛出 同步到页面外部产品弹框
				try{
					await this.getDataList();
				} catch{
					// 最终达到网址有值，但未匹配到,则打开产品数据弹框
					this.$refs.selectProductDetail.dialogVisible = true; // 打开产品数据弹框
					return false;
				}
				if(type===1){
					this.aiTitle='自动生成广告标题';
				}else{
					this.aiTitle = '自动生成广告说明'
				}
				this.selecteditem = {
					imgPath: (this.selectProductList[0].thumbnails &&　this.selectProductList[0].thumbnails.length ? this.selectProductList[0].thumbnails[0].url : ''),
					title: this.selectProductList[0].name,
					automationContentId: sessionStorage.getItem('projectId'), //站点id
				};
				this.titleDrawer = true;
			})
    },
		async getDataList() {
			let params = {
				siteid: sessionStorage.getItem('projectId'), //站点id
				url: this.ruleForm.finalUrls,
			};
			let res = await adsNewOnline.productListAd(params);
			return res
		},
	}
};
</script>
<style lang="scss" scoped>
.skySlogan {
	display: flex;
	&>.info {
		flex: 3;
		.batch {
			float: right;
			margin-right: 40px;
			font-size: 14px;
			color: #3da1ff;
			cursor: pointer;
		}
	}
	&>.preview {
		flex: 2;
	}
	.preInfo {
		border: 1px solid #DCDFE6;
		padding: 8px;
		border-radius: 5px;
	}
	.tit {
    color: #409eff;
  }
	.el-input {
		width: 82%;
	}
}
</style>